import Vue from 'vue'
import MxTable from './index.vue'

Vue.component('MxTable', MxTable)



// WEBPACK FOOTER //
// ./src/components/Table/MxTable/table.js